'use strict';

import React from 'react';
import {Link} from 'react-router';
import Moment from 'moment';
import 'styles/Item.scss';

class ItemComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {type,id,cover,title,price,feature,status} = this.props;
    let {name,wechat,email,tel} = this.props;
    let {start,end,desc,create_date} = this.props;
    if(type == 1){
      return (
        <Link key={id} className="item item-default mb-10">
          <div className="cover mr-5">
            <img src={cover} />
          </div>
          <div className="title">
            {title}
          </div>
          <div className="clear"></div>
        </Link>
      );
    }else if(type == 2){
      let color, tag;
      if(status == 1){
        color = "color1";
        tag = "待付款";
      }else if(status == 2){
        color = "color2";
        tag = "拼团中";
      }else if(status == 3){
        color = "color3";
        tag = "待出行";
      }else if(status == 4){
        color = "color4";
        tag = "待评价";
      }else if(status == 5){
        color = "color5";
        tag = "已退款";
      }
      return (
        <Link key={id} className="item item-order mb-10">
          <div className="title">
            {title}
          </div>
          <div className="description">
            {desc}
          </div>
          <div className="schedual">
            出发时间：<span className="date">{start}</span>&nbsp;&nbsp;&nbsp;&nbsp;
            结束时间：<span className="date">{end}</span>
          </div>
          <div className="schedual">
            订单金额：<span className="price">¥{price}</span>
          </div>
          <div className="order-time">
            <span className={`tag ${color}`}>{tag}</span>创建于&nbsp;{Moment(create_date).format('YYYY-MM-DD HH:MM')}
          </div>
        </Link>
      );
    }else if(type == 3){
      return (
        <Link key={id} className="item item-two mb-10">
          <div className="cover mr-5">
            <img src={cover} />
          </div>
          <div className="title">
            {title}
          </div>
          <div className="price">¥{price}</div>
          <div className="feature">{feature}</div>
          <div className="clear"></div>
        </Link>
      );
    }else if(type == 4){
      return (
        <div key={id} className="item item-three mb-10">
          <div className="name">姓名：{name}</div>
          <div className="tel">电话：{tel}</div>
          <div className="email">电话：{email}</div>
          <div className="wechat">微信号：{wechat}</div>
        </div>
      );
    }else{
      return (
        <Link key={id} className="item item-default mb-10">
          <div className="cover mr-5">
            <img src={cover} />
          </div>
          <div className="title">
            {title}
          </div>
          <div className="clear"></div>
        </Link>
      );
    }
  }
}

ItemComponent.displayName = 'ItemComponent';
export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/ItemComponent.js